import { Icon } from '@iconify/react'
import { useStorefrontContent } from '@/branding/BrandingProvider'

export function FourPillarsSection() {
  const { pillars } = useStorefrontContent()
  const delays = [100, 200, 300, 400] as const

  return (
    <section id="features" className="py-24 bg-white border-b border-slate-100">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16 reveal-base">
          <h2 className="text-3xl font-medium tracking-tight text-navy mb-4">{pillars.title}</h2>
          <p className="text-slate-600 max-w-2xl mx-auto font-light">{pillars.subtitle}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {pillars.items.map((pillar, i) => (
            <div
              key={pillar.title}
              className={`p-8 rounded-[2rem] bg-slate-50 border border-slate-100 hover:shadow-lg transition-shadow reveal-base delay-${delays[i]} group`}
            >
              <div className="w-12 h-12 rounded-xl bg-white border border-slate-200 flex items-center justify-center text-navy mb-6 group-hover:scale-110 transition-transform">
                <Icon icon={pillar.icon} className="text-2xl" />
              </div>
              <h3 className="text-xl font-medium tracking-tight text-navy mb-3">{pillar.title}</h3>
              <p className="text-sm text-slate-600 font-light leading-relaxed">{pillar.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
